import { IoClose } from "react-icons/io5";
import "./BotaoFechar.css";

const BotaoFechar = ({ 
    onClick, 
    ariaLabel = "Fechar" 
}) => {
    return (
        <button
            className="botao-fechar"
            onClick={onClick}
            aria-label={ariaLabel}
            type="button"
        >
            <IoClose size={22} />
        </button>
    );
};

export default BotaoFechar;